<template>
    <div>
        <tab name="6"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue1" class="input-with-select" size="small">
                        <el-select v-model="params.searchType1" slot="prepend" placeholder="请选择">
                            <el-option label="巡演ID" :value="1"></el-option>
                            <el-option label="巡演名称" :value="2"></el-option>
                            <el-option label="艺人ID" :value="3"></el-option>
                            <el-option label="艺人名称" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">                    
					<div class="clearfix timeType">
					    <el-input class="input-with-select fl" size="small">
					        <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
					            <el-option label="下单时间" :value="1"></el-option>
					        </el-select>
					    </el-input>
					    <el-date-picker
					        v-model="params.time"
					        type="datetimerange"
					        range-separator="-"
					        start-placeholder="开始时间"
					        end-placeholder="结束时间"
					        size="small"
					        value-format="yyyy-MM-dd HH:mm:ss"
					        :default-time="['00:00:00', '23:59:59']"
					        style="width: 100%;"
					        unlink-panels
					        >
					    </el-date-picker>
					</div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示实际收入最多的" :value="1"></el-option>
                        <el-option label="优先展示总订单数最多的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <template v-if="statistics">
            <div class="page-group-title"><span>汇总统计</span></div>
            <el-card v-loading="fetchStatisticsLoading" shadow="never" class="statistics-box">
                <el-row :gutter="20">
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.tourNum || 0}}</p><p class="color-info">巡演总数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.amount || '0.00'}}</p><p class="color-info">实际收入</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.orderNum || 0}}</p><p class="color-info">总订单数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.totalNum || 0}}</p><p class="color-info">售票数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.discounts || '0.00'}}</p><p class="color-info">优惠金额</p></el-col>
                </el-row>
            </el-card>
        </template>
        <div class="page-group-title"><span>统计列表</span></div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
               <el-table-column prop="tourId" label="巡演ID" :min-width="150"></el-table-column>
               <el-table-column prop="tourName" label="巡演名称" :min-width="150" show-overflow-tooltip></el-table-column>
               <el-table-column prop="performerName" label="艺人" :min-width="150" show-overflow-tooltip></el-table-column>
               <el-table-column prop="amount" label="实际收入" :min-width="150"></el-table-column>
               <el-table-column prop="orderNum" label="总订单数" :min-width="150"></el-table-column>
               <el-table-column prop="totalNum" label="售票数" :min-width="150"></el-table-column>
               <el-table-column prop="discounts" label="优惠金额" :min-width="150"></el-table-column>
                <el-table-column label="操作" fixed="right" :width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="text" @click="toDate(scope.row)">查看日期明细</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="pageSizeChange"
                @current-change="pageNoChange"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from './../../components/tab';

export default {
    components:{Tab},
    data(){
        this.defaultParams = {
            searchType1: 1,
            searchValue1: null,
            timeStartStr: null,
            timeEndStr: null,
            sort: 1,
            pageNo: 1,
            pageSize: this.$pageSizes[0],
			timeType:1
        };

        const params = this.parsing();

        return{
            statistics: null,
            fetchStatisticsLoading: false,
            data: null,
            dataList: null,
            params: {...params},
            listLoading: false,
            filter: null
        }
    },
    created() {
        this.$router.replace({path: '/report/sales/touring', query: {...this.$route.query, t: Date.now()}});
        this.getStatistics();
    },
    watch: {
        '$route.query': function() {
            this.getDataList();
        }
    },
    methods:{
        parsing() {
            const {searchType1, searchValue1, timeStartStr, timeEndStr, sort, pageNo, pageSize} = {...this.defaultParams, ...this.$route.query};
            return {
                searchType1: parseInt(searchType1), 
                searchValue1, 
                time: timeStartStr && timeEndStr ? [timeStartStr, timeEndStr] : [], 
                sort: parseInt(sort), 
                pageNo: parseInt(pageNo), 
                pageSize: parseInt(pageSize),
				timeType:1
            };
        },
        //获取列表
        async getDataList() {
            const {time, ...params} = this.parsing();
            const [timeStartStr, timeEndStr] = time || [];

            this.listLoading = true;

            const res = await this.$request({
                url: '/sales/tour/list',
                method: 'post',
                data: {...params, timeStartStr, timeEndStr}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
            this.filter = {...params, timeStartStr, timeEndStr};
        },
         //选择pageSize
        pageSizeChange() {
            if(this.isTimeError()) return;
            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStartStr, timeEndStr] = time || [];
            this.$router.replace({path: '/report/sales/touring', query: {...params, timeStartStr, timeEndStr, t: Date.now()}});
        },
        pageNoChange() {
            if(this.isTimeError()) return;
            const {time, ...params} = this.params;
            const [timeStartStr, timeEndStr] = time || [];
            this.$router.replace({path: '/report/sales/touring', query: {...params, timeStartStr, timeEndStr, t: Date.now()}});
        },
        //搜索
        search() {
            if(this.isTimeError()) return;
            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStartStr, timeEndStr] = time || [];
            this.$router.replace({path: '/report/sales/touring', query: {...params, timeStartStr, timeEndStr, t: Date.now()}});
            this.getStatistics();
        },
        //重置搜索
        reset() {
            const {timeStartStr, timeEndStr, ...params} = this.defaultParams;
            this.params = {
                ...params,
                time: timeStartStr && timeEndStr ? [timeStartStr, timeEndStr] : [],
            };
            this.$router.replace({path: '/report/sales/touring', query: {...params, timeStartStr, timeEndStr, t: Date.now()}});
            this.getStatistics();
        },
        isTimeError() {
            const {time} = this.params;
            const [timeStart, timeEnd] = time || [];

            if(!timeStart || !timeEnd) {
                return false;
            }

            if(new Date(timeEnd).getTime() - new Date(timeStart).getTime() > 730 * 24 * 60 *60 *1000) {
                this.$alert('目前支持查询最多2年的数据', '提示', {confirmButtonText: '确认', type: 'warning', center: true});
                return true;
            }

            return false;
        },
        async getStatistics() {
            const {time, ...params} = this.params;
            const [timeStartStr, timeEndStr] = time || [];


            this.fetchStatisticsLoading = true;

            const res = await this.$request({
                url: '/sales/tour/sum',
                method: 'post',
                data: {...params, timeStartStr, timeEndStr}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.fetchStatisticsLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.statistics = result || {};
        },
        toDate(row) {
            const {tourId} = row;
            const {timeStartStr, timeEndStr} = this.filter;
            this.$router.push({path: '/report/sales/touring/date', query: {tourId, timeStartStr, timeEndStr}});
        }
    }
}
</script>

<style lang="scss" scoped>
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>